//services
import { map } from 'lodash';

import API from 'services/api';

// Accommodation
export const getCurrencies = () => API.get('/api/accommodation/currencies');
export const getObjectsTypes = () => API.get('/api/accommodation/objects/types');
export const getObjectsCategories = () => API.get('/api/accommodation/objects/prefix');
export const getObjectsCities = () => API.get('/api/accommodation/objects/cities');
export const getServices = () => API.get('/api/accommodation/services');
export const getUnitMeasures = () => API.get('/api/accommodation/unit-measures');
export const getResidentialTaxes = () => API.get('/api/accommodation/residential-taxes');
export const getDiscountApplyPriceTypes = () =>
  API.get('api/accommodation/discount-applypricetypes');
export const getDiscountFeeTypes = () => API.get('api/accommodation/discount-feetypes');
export const getDiscountPackages = () => API.get('/api/accommodation/discounts');
export const getUnitsTypes = objectType => API.get(`/api/accommodation/units/types/${objectType}`);
export const getAllProperties = () => API.get(`/api/accommodation/properties/all`);
export const getAllUnits = propertyId =>
  API.get(`/api/accommodation/properties/${propertyId}/units/all`);
export const getPartners = () => API.get(`/api/accommodation/partners`);
export const getRoomsTypes = unitTypeId =>
  API.get(`/api/accommodation/units/rooms/types/${unitTypeId}`);

// Properties
export const getProperties = (pageNo = 1, pageSize = 12, params = {}) =>
  API.get(`/api/accommodation/properties?PageNo=${pageNo}&PageSize=${pageSize}`, {
    params: params,
  });
export const getProperty = propertyId => API.get(`/api/accommodation/properties/${propertyId}`);
export const createProperty = ({ payload }) => API.post('/api/accommodation/properties', payload);
export const updateProperty = ({ propertyId, payload }) =>
  API.put(`/api/accommodation/properties/${propertyId}`, payload);

export const getPropertyTranslations = propertyId =>
  API.get(`/api/accommodation/properties/${propertyId}/translations`);
export const updatePropertyTranslations = ({ propertyId, payload }) =>
  API.put(`/api/accommodation/properties/${propertyId}/translations`, payload);

export const getPropertyUnitsNoParams = propertyId =>
  API.get(`api/accommodation/properties/${propertyId}/units`);
export const getPropertyUnits = (propertyId, page = 1, pageSize = 12, params = {}) =>
  API.get(`api/accommodation/properties/${propertyId}/units?PageNo=${page}&PageSize=${pageSize}`, {
    params: params,
  });
export const createPropertyUnit = ({ propertyId, payload }) =>
  API.post(`/api/accommodation/properties/${propertyId}/units`, payload);

export const getPropertyPriceList = ({ propertyId, currentYear }) =>
  API.get(`/api/accommodation/properties/${propertyId}/units/pricelist`, {
    params: {
      filterByYear: currentYear,
    },
  });
export const getPropertyUnitsDiscounts = ({ propertyId, currentYear }) =>
  API.get(`/api/accommodation/properties/${propertyId}/units/discounts`, {
    params: {
      filterByYear: currentYear,
    },
  });

// Fees and taxes
export const getFeesAndTaxes = ({ propertyId, currentYear }) =>
  API.get(`/api/accommodation/properties/${propertyId}/units/feestaxes`, {
    params: {
      filterByYear: currentYear,
    },
  });
export const createFeeAndTax = ({ payload }) =>
  API.post('/api/accommodation/unit-fees-taxes', payload);
export const getFeeAndTax = unitFeesTaxesId =>
  API.get(`/api/accommodation/unit-fees-taxes/${unitFeesTaxesId}`);
export const updateFeeAndTax = ({ unitFeesTaxesId, payload }) =>
  API.put(`/api/accommodation/unit-fees-taxes/${unitFeesTaxesId}`, payload);
export const deleteFeeAndTax = unitFeesTaxesId =>
  API.delete(`/api/accommodation/unit-fees-taxes/${unitFeesTaxesId}`);

// Images
export const getImage = ({ imageId }) => API.get(`api/accommodation/images/${imageId}`);
export const uploadImage = ({ imageId, payload }) =>
  API.put(`api/accommodation/images/${imageId}`, payload);
export const deleteImage = imageId => API.delete(`api/accommodation/images/${imageId}`);
export const uploadPropertyImages = ({ propertyId, data }) => {
  return API.post(`/api/accommodation/properties/${propertyId}/images/multiple`, data, {
    headers: {
      'Content-Type': 'multipart/form-data;',
    },
  });
};

export const getPropertyGalleries = propertyId =>
  API.get(`api/accommodation/properties/${propertyId}/galleries`);
export const updatePropertyGalleries = ({ propertyId, data }) =>
  API.put(`/api/accommodation/properties/${propertyId}/galleries`, data);

// Channel Manager
export const getCMPartners = () => API.get('/api/accommodation/channel-manager/partners');
export const getCMPartnerInfo = partnerId =>
  API.get(`/api/accommodation/channel-manager/partners/${partnerId}`);
export const updateCMPartnerInfo = ({ partnerId, payload }) =>
  API.put(`/api/accommodation/channel-manager/partners/${partnerId}`, payload);

export const getCMPartnerSettings = partnerId =>
  API.get(`/api/accommodation/channel-manager/partners/${partnerId}/settings`);
export const updateCMPartnerSettings = ({ partnerId, payload }) =>
  API.put(`/api/accommodation/channel-manager/partners/${partnerId}/settings`, payload);

export const getCMPartnerPropertiesSettings = partnerId =>
  API.get(
    `/api/accommodation/channel-manager/partners/${partnerId}/settings/properties?gridView=true`,
  );

export const getCMRentalPartnerSettings = ({ partnerId, propertyId, gridView = false }) =>
  API.get(
    `/api/accommodation/channel-manager/partners/${partnerId}/settings/properties/${propertyId}?gridView=${gridView}`,
  );
export const updateCMRentalPartnerSettings = ({ partnerId, propertyId, payload }) =>
  API.put(
    `/api/accommodation/channel-manager/partners/${partnerId}/settings/properties/${propertyId}`,
    { settings: payload },
  );

export const getCMUnitPartnerSettings = ({ partnerId, unitId }) =>
  API.get(`/api/accommodation/channel-manager/partners/${partnerId}/settings/units/${unitId}`);
export const updateCMUnitPartnerSettings = ({ partnerId, unitId, payload }) =>
  API.put(`/api/accommodation/channel-manager/partners/${partnerId}/settings/units/${unitId}`, {
    settings: payload,
  });

// Unit Pricelist
export const getUnitPriceList = unitPriceListId =>
  API.get(`/api/accommodation/unit-pricelist/${unitPriceListId}`);
export const createUnitPriceList = ({ payload }) =>
  API.post(`/api/accommodation/unit-pricelist`, payload);
export const updateUnitPriceList = ({ unitPriceListId, payload }) =>
  API.put(`/api/accommodation/unit-pricelist/${unitPriceListId}`, payload);
export const deleteUnitPriceList = unitPriceListId =>
  API.delete(`/api/accommodation/unit-pricelist/${unitPriceListId}`);

// Unit Discount
export const activateUnitDiscount = unitDiscountId => {
  return API.post(`/api/accommodation/unit-discount/${unitDiscountId}/activate`);
};
export const deactivateUnitDiscount = unitDiscountId => {
  return API.post(`/api/accommodation/unit-discount/${unitDiscountId}/deactivate`);
};

// Discount packages
export const getDiscountsPackages = () => API.get('/api/accommodation/discounts');
export const deleteUnitDiscount = unitDiscountId =>
  API.delete(`/api/accommodation/unit-discount/${unitDiscountId}`);
// Unit Discount: FIRST-MINUTE
export const getFirstMinuteDiscount = unitDiscountId => {
  return API.get(`/api/accommodation/unit-discount/firstminute/${unitDiscountId}`);
};
export const createFirstMinuteDiscount = ({ payload }) => {
  return API.post('/api/accommodation/unit-discount/firstminute', payload);
};
export const updateFirstMinuteDiscount = ({ payload, unitDiscountId }) => {
  return API.put(`/api/accommodation/unit-discount/firstminute/${unitDiscountId}`, payload);
};
// Unit Discount: LONG-STAY
export const getLongerStayDiscount = unitDiscountId => {
  return API.get(`/api/accommodation/unit-discount/longstay/${unitDiscountId}`);
};
export const createLongerStayDiscount = ({ payload }) => {
  return API.post('/api/accommodation/unit-discount/longstay', payload);
};
export const updateLongerStayDiscount = ({ payload, unitDiscountId }) => {
  return API.put(`/api/accommodation/unit-discount/longstay/${unitDiscountId}`, payload);
};
// Unit Discount: LAST-MINUTE
export const getLastMinuteDiscount = unitDiscountId => {
  return API.get(`/api/accommodation/unit-discount/lastminute/${unitDiscountId}`);
};
export const createLastMinuteDiscount = ({ payload }) => {
  return API.post('/api/accommodation/unit-discount/lastminute', payload);
};
export const updateLastMinuteDiscount = ({ payload, unitDiscountId }) => {
  return API.put(`/api/accommodation/unit-discount/lastminute/${unitDiscountId}`, payload);
};
// Unit Discount: Promotion
export const getPromotionDiscount = unitDiscountId => {
  return API.get(`/api/accommodation/unit-discount/promotion/${unitDiscountId}`);
};
export const createPromotionDiscount = ({ payload }) => {
  return API.post('/api/accommodation/unit-discount/promotion', payload);
};
export const updatePromotionDiscount = ({ payload, unitDiscountId }) => {
  return API.put(`/api/accommodation/unit-discount/promotion/${unitDiscountId}`, payload);
};

// Payment models
export const getPaymentModelsFromRoot = () => API.get('/api/root/payment-models');
export const getPaymentCodeFromRoot = () => API.get('api/root/payment-models/all');
export const getPropertyTypesFromRoot = () => API.get('api/root/property-types/all');

export const getCountriesFromRoot = () => API.get('/api/root/countries/all');
export const getLanguagesFromRoot = () => API.get('/api/root/languages/all');

// Partners-suppliers
export const _getPartner = ({ partnerId }) => API.get(`/api/partners/${partnerId}`);
export const getPartnersSuppliers = ({ pageNo, pageSize }) => {
  return API.get(`/api/partners/suppliers?PageNo=${pageNo}&PageSize=${pageSize}`);
};

export const getPartnersContractType = () => API.get('/api/partners/contract-type/all');
export const getPartnersOptionType = () => API.get('/api/partners/partner-option-type/all');
export const _getContractPartners = () => API.get('/api/partners/all');
export const _getPartnersCooperationType = () => API.get('/api/cooperation-types/all');

// Partners -> bank
export const getBanks = () => API.get('/api/banks/all');
export const createBank = payload => API.post('/api/banks', payload);

export const getPartnerAccountType = () => API.get('/api/partners/account-type/all');

export const getPartnerBankAccount = ({ partnerId }) =>
  API.get(`/api/partners/${partnerId}/bank-accounts`);
export const createPartnerBankAccount = ({ partnerId, payload }) =>
  API.post(`/api/partners/${partnerId}/bank-accounts`, payload);

export const getCurrenciesFromRoot = () => API.get('/api/root/currencies/all');

// Partners - contacts
export const getCities = () => API.get('/api/cities/all');
export const getPartnerContactsAccounts = ({ partnerId }) =>
  API.get(`/api/partners/${partnerId}/contacts`);
export const createPartnerContactsAccounts = ({ partnerId, payload }) =>
  API.post(`/api/partners/${partnerId}/contacts`, payload);

// Contracts
export const _getContractsPaymentModel = () => API.get('/api/contracts/option-payment-model/all');

export const _getPropertyContracts = ({ propertyId }) =>
  API.get(`api/accommodation/properties/${propertyId}/contracts`);
export const _createPropertyContract = ({ propertyId, payload }) =>
  API.post(`api/accommodation/properties/${propertyId}/contracts`, payload);
export const _getPropertyActiveContracts = ({ propertyId }) =>
  API.get(`api/accommodation/properties/${propertyId}/contracts/all`);

export const _getContract = ({ contractId }) => API.get(`api/contracts/${contractId}`);
export const _updateContract = ({ contractId, payload }) =>
  API.put(`api/contracts/${contractId}`, payload);

export const _getUnitsContractsList = ({ contractId }) =>
  API.get(`api/contracts/${contractId}/items`);
export const _updateUnitContract = ({ contractId, unitId }) =>
  API.put(`api/contracts/${contractId}/items/${unitId}`);
